export default {
  dispatchToken({ commit }, token) {
    commit("setToken", token);
  },
  dispatchClientStatus({ commit }, status) {
    commit("setClientStatus", status);
  },

  dispatchEmployee({ commit }, object) {
    commit("setEmployee", object);
  },
  dispatchCompanies({ commit }, array) {
    commit("setCompanies", array);
  },
  dispatchCompany({ commit }, object) {
    commit("setCompany", object);
  },
  dispatchSubCompany({ commit }, object) {
    commit("setSubCompany", object);
  },
  dispatchSubCompanies({ commit }, array) {
    commit("setSubCompanies", array);
  },
  dispatchInitialMenu({ commit }, array) {
    commit("setInitialMenu", array);
  },
  dispatchMenu({ commit }, array) {
    commit("setMenu", array);
  },
  dispatchMainMenu({ commit }, array) {
    commit("setMainMenu", array);
  },
  dispatchCompanyMenu({ commit }, array) {
    commit("setCompanyMenu", array);
  },
  dispatchSubCompanyMenu({ commit }, array) {
    commit("setSubCompanyMenu", array);
  },
  dispatchModule({ commit }, array) {
    commit("setModule", array);
  },
  dispatchInfobar({ commit }, object) {
    commit("setInfobar", object);
  },
  dispatchInfobarStatus({ commit }, object) {
    commit("setInfobarStatus", object);
  },
  dispatchEnableNavDrawer({ commit }, boolean) {
    commit("setEnableNavDrawer", boolean);
  },
  startLoading({ commit }) {
    commit("setLoading", true);
  },
  endLoading({ commit }) {
    // setTimeout(() => {
    commit("setLoading", false);
    // }, 600);
  },
  dispatchUnauthorized({ commit }, status) {
    commit("setUnauthorized", status);
  },
  dispatchTempData({ commit }, array) {
    commit("setTempData", array);
  },
  dispatchFareMatrixItems({ commit }, array) {
    commit("setFareMatrixItems", array);
  },
  editFareMatrixItems({ commit }, object) {
    commit("editFareMatrixItems", object);
  },
  clearStore({ commit }) {
    try {
      commit("setToken", null);
      commit("setClientStatus", false);
      commit("setTempData", null);
      commit("setEmployee", {});
      commit("setCompanies", []);
      commit("setSubCompanies", []);
      commit("setInitialMenu", []);
      commit("setMenu", []);
      commit("setMainMenu", []);
      commit("setCompanyMenu", []);
      commit("setSubCompanyMenu", []);
      commit("setLoading", false);
      commit("setCompany", {});
      commit("setSubCompany", {});
      commit("setEnableNavDrawer", false);
    } catch (error) {
      console.log(error);
    }
  }
};
